import { render } from "./AnimalDetail.vue?vue&type=template&id=81a93ff2&scoped=true"
import script from "./AnimalDetail.vue?vue&type=script&lang=js"
export * from "./AnimalDetail.vue?vue&type=script&lang=js"

import "./AnimalDetail.vue?vue&type=style&index=0&id=81a93ff2&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a93ff2"]])

export default __exports__